import { useSelector } from 'react-redux';
import { selectApplication } from '../store/selectors/applicationSelectors';

const useBankApplicationFundingData = () => {
  const Application = useSelector(selectApplication);

  const { BankApplicationFunding } = Application;

  return { BankApplicationFunding };
};

export default useBankApplicationFundingData;
